import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';
import { assignMetadata } from '@polyai/stream/store/utils/assign-metadata';

import { createReferenceAdapter } from '../../references';
import {
  createStopKeywords,
  deleteStopKeywords,
  updateStopKeywords,
} from './actions';
import type { StopKeywords, StopKeywordsState } from './types';

const stopKeywordsAdapter = createEntityAdapter<StopKeywords>();

export const stopKeywordsSelectors = stopKeywordsAdapter.getSelectors();

const stopKeywordReferences = createReferenceAdapter(['globalFunctions']);

const initialState: StopKeywordsState = {
  filters: stopKeywordsAdapter.getInitialState(),
};

const slice = createSlice({
  name: 'stopKeywords',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(createStopKeywords, (state, action) => {
      const entityWithDefaults = {
        ...action.payload,
        languageCode: action.payload.languageCode ?? '',
        createdBy: '',
        createdAt: '',
        updatedBy: '',
        updatedAt: '',
      };
      assignMetadata(action, entityWithDefaults);
      stopKeywordsAdapter.addOne(state.filters, entityWithDefaults);
    });

    builder.addCase(updateStopKeywords, (state, action) => {
      const filter = stopKeywordsSelectors.selectById(
        state.filters,
        action.payload.id,
      );
      const updatedEntity = {
        ...filter,
        ...action.payload,
      };
      assignMetadata(action, updatedEntity);
      stopKeywordsAdapter.upsertOne(state.filters, updatedEntity);
    });

    builder.addCase(deleteStopKeywords, (state, action) => {
      stopKeywordsAdapter.removeOne(state.filters, action.payload.id);
    });
  },
});

export {
  createStopKeywords,
  deleteStopKeywords,
  stopKeywordReferences,
  stopKeywordsAdapter,
  updateStopKeywords,
};
export type { StopKeywords, StopKeywordsState };

export const selectStopKeywords = (state: RootState) => state.stopKeywords;

export default slice.reducer;
